import React from "react";
import { Eye, LogOut } from "lucide-react";
import { useApp } from "../context";
import { PREVIEW_LABELS, clearPreviewSession, getPreviewFromLocation } from "../utils/previewScenario";

// Slim sticky bar shown ONLY inside a preview session (the admin Preview Studio
// iframe, or a shared ?preview= deep link). Makes it obvious you're viewing as
// a persona and lets a standalone tab exit back to the real site.
const PreviewSessionBanner = () => {
  const { user } = useApp();
  if (!user?.preview_session) return null;
  const label = PREVIEW_LABELS[user.preview_scenario] || user.preview_scenario;
  const note = (getPreviewFromLocation() || {}).note || "";
  const exit = () => { clearPreviewSession(); window.location.href = "/"; };
  return (
    <div
      data-testid="preview-session-banner"
      className="w-full bg-indigo-600 text-white text-center py-1.5 px-3 text-xs font-bold flex flex-wrap items-center justify-center gap-2"
    >
      <Eye size={13} className="text-amber-200" />
      <span data-testid="preview-session-label">Preview — viewing the site as {label}</span>
      {note ? <span data-testid="preview-session-note" className="font-normal italic text-indigo-100 border-l border-white/25 pl-2">“{note}”</span> : null}
      <button onClick={exit} data-testid="preview-session-exit" className="ml-2 inline-flex items-center gap-1 rounded-full bg-black/30 hover:bg-black/50 px-2.5 py-0.5 text-[11px]">
        <LogOut size={11} /> Exit
      </button>
    </div>
  );
};

export default PreviewSessionBanner;
